import { render, staticRenderFns } from "./ProcessSampleModal.vue?vue&type=template&id=22579eb4"
import script from "./ProcessSampleModal.vue?vue&type=script&lang=js"
export * from "./ProcessSampleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports